import breadcrumbIcon from "../../assets/breadcrumb/breadcrumb-icon.svg";
import { useAuth } from "../../context/AuthContext";

const BreadCumb = ({ clientName }: any) => {
    const { userInfo } = useAuth();
    const agencyName = userInfo?.agencies?.company_name;

    return (
        <ul className="flex mq825:flex-wrap my-0 gap-[8px] pl-0 w-full breadcrumb-section-dv">
            <li className="block">
                <p className="  cursor-pointer underline text-text-text-secondary  text-sm">
                    {agencyName}
                </p>
            </li>

            {clientName && (
                <>
                    <span>
                        <img src={breadcrumbIcon} className=" w-4 h-4  dark-white-img relative top-[4px]" alt="" />
                    </span>
                    <li className="block">
                        <p className="cursor-pointer underline text-text-text-secondary text-sm last_anchor_dv">
                            {clientName}
                        </p>
                    </li>
                </>

            )}
        </ul>
    );
};

export default BreadCumb;
